import { useQuery } from '@tanstack/react-query';
import type { CompetitorAnalysis, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCompetitorAnalyses(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['competitor-analyses', { projectId, limit }],
    queryFn: () =>
      apiGet<CursorPage<CompetitorAnalysis>>(
        `/v1/competitor-analyses?${params.toString()}`,
      ),
  });
}
